<template>
  <div class="hb">
    <div class="hbbox">
      <img v-if="is_show" class="bg" src="../assets/hb.jpg" />
      <img
        v-if="is_show"
        class="chai"
        :style="rotateY && 'transform:rotateY(720deg)'"
        src="../assets/chai.png"
        @click="open(id)"
      />
      <div v-if="is_show" class="inner">{{ desc }}</div>
      <img v-if="!is_show" class="bg" src="../assets/hb2.png" />
      <div v-if="!is_show" class="money">
        <p>{{ content }}元</p>
        <div class>红包已发放到您的微信余额，请注意查收</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rotateY: false,
      id: "",
      content: "",
      desc: "",
      is_show: true
    };
  },
  created() {
    let sn = this.$route.query.sn;
    this.$http({
      url: "redenvelopesDetail",
      data: {
        sn
      }
    })
      .then(res => {
        this.id = res.id;
        this.money = res.money;
        this.desc = res.redenvelopes_title;
      })
      .catch(err => {
        if (err.response.status == 301) {
          
          this.$toast(err.response.data);
          
        }else if(err.response.status == 302){

          this.$toast(err.response.data);

           setTimeout(() => {

             this.$router.replace({name:'index'})

          }, 1000);
        }
      });
  },
  methods: {
    open(id) {
      this.rotateY = true;
      this.$http({
        url: "pickRedenvelopes",
        data: {
          id
        }
      })
        .then(res => {
          this.content = res;

          setTimeout(() => {

            this.is_show = false;

          }, 2000);

        })
        .catch(err => {
          console.log(err.response);
          this.$dialog
            .alert({
              message: err.response.data
            })
            .then(() => {
              this.$router.replace({ name: "index" });
            });
        });
    }
  }
};
</script>

<style lang="less" scoped>
.hb {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  background-color: #fa4635;
  .hbbox {
    width: 100%;
    // height: 100%;
    position: relative;
    .bg {
      width: 100%;
    }
    .chai {
      position: absolute;
      top: 740px;
      left: 50%;
      margin-left: -117px;
      transition: all 2s;
      width: 31.14%;
      // height: ;
    }
    .inner {
      width: 550px;
      height: 100px;
      line-height: 100px;
      margin: 0 auto;
      font-size: 90px;
      color: #fff;
      position: absolute;
      top: 300px;
      left: 50%;
      margin-left: -275px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .money {
      font-size: 32px !important;
      font-weight: 600 !important;
      color: #d65243 !important;
      width: 340px;
      position: absolute;
      top: 330px;
      left: 50%;
      margin-left: -170px;
      text-align: center;
      line-height: 50px;
    }

    .money div {
      color: #666;
    }
  }
}
</style>